import { request } from "/src/utils/index.js";

export function Search(params) {
  // console.log(parmas);
  return request.get("tcm/healthAssessment/list", { params });
}

export function Detail(params) {
  // console.log(parmas);
  return request.get("tcm/healthAssessment/detail", { params });
}

export function Add(params) {
  return request.post("tcm/healthAssessment", params);
}

export function Delete(data) {
  return request.delete("tcm/healthAssessment", { data });
}
